/* eslint-disable no-nested-ternary */

export class EnvDetector {
  static create() {
    return new EnvDetector()
  }

  getEnv(): 'node' | 'browser' | 'unknown' {
    return typeof globalThis.window === 'object' && typeof document === 'object' ? 'browser': // prettier-ignore
           typeof process === 'object' && process?.versions?.node ? 'node' :                  // prettier-ignore
           'unknown' // prettier-ignore
  }
}
